import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ChangeImpactReviewList from './ChangeImpactReviewList.jsx';
import ParticipationsTree from '../../ParticipationsTree.jsx';
import ToggleShowMore from '../../ToggleShowMore.jsx';

const ChangeImpactWhoIsImpacted = ({
  participants,
  stakeholderParticipations,
}) => {
  return (
    <div className="component component-bg-white">
      <Row>
        <Col xs={4}>
          <ToggleShowMore
            limit={5}
            entities={participants.impactedGroups}
            customClass="component-margin-bottom"
          >
            <ChangeImpactReviewList title="Group, Team, Department" />
          </ToggleShowMore>
        </Col>

        <Col xs={4}>
          <h3 className="flex text-muted m-b-12">People</h3>

          {participants.impactedEmployees.length ? (
            <ToggleShowMore
              tree
              limit={5}
              entities={participants.impactedEmployees}
            >
              <ParticipationsTree />
            </ToggleShowMore>
          ) : (
            <div>—</div>
          )}
        </Col>

        <Col xs={4}>
          <ToggleShowMore
            limit={5}
            entities={participants.impactedExternalEntities}
            customClass="component-margin-bottom"
          >
            <ChangeImpactReviewList title="External Group, Team, Department" />
          </ToggleShowMore>
        </Col>
      </Row>

      <Row>
        <Col xs={4}>
          <h3 className="flex text-muted m-b-12">Stakeholders</h3>
          {stakeholderParticipations?.length ? (
            <ToggleShowMore tree limit={5} entities={stakeholderParticipations}>
              <ParticipationsTree />
            </ToggleShowMore>
          ) : (
            <div>—</div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ChangeImpactWhoIsImpacted;
